import createApp from 'createApp'
const categorySupplier = () => import('Components/CategoryDirectory/categorySupplier.vue')
const categoryBestCompany = () => import('Components/CategoryDirectory/categoryBestCompany.vue')
const categoryCompanyGrid = () => import('Components/CategoryDirectory/categoryCompanyGrid.vue')
const categoryInformation = () => import('Components/CategoryDirectory/categoryInformation.vue')
const categoryJumbotron = () => import('Components/CategoryDirectory/categoryJumbotron.vue')
const categoryQuestion = () => import('Components/CategoryDirectory/categoryQuestion.vue')
const categoryQuestionBox = () => import('Components/CategoryDirectory/categoryQuestionBox.vue')
const categoryRegionList = () => import('Components/CategoryDirectory/categoryRegionList.vue')
const categoryCitySearch = () => import('Components/CategoryDirectory/categoryCitySearch.vue')
const categoryBreadcrumb = () => import('Components/CategoryDirectory/categoryBreadcrumb.vue')

createApp({
  components: {
    categorySupplier,
    categoryBestCompany,
    categoryCompanyGrid,
    categoryInformation,
    categoryJumbotron,
    categoryQuestion,
    categoryQuestionBox,
    categoryRegionList,
    categoryCitySearch,
    categoryBreadcrumb
  }
})

